export default {
  API_URL: 'https://wes-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://wessandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
